import React, { Component } from 'react';
import { PhotoSwipe } from 'react-photoswipe';

export default class PhotoSwipeWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = { isOpen: false, items: [], options: { closeOnScroll: false } }
    this.openPhotoSwipe = this.openPhotoSwipe.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  openPhotoSwipe(e, file, title) {
    e.preventDefault();
    this.setState({ isOpen: true, items: [ { src: file.url, w: file.width, h: file.height, title: title } ] });
  }

  handleClose() {
    this.setState({ isOpen: false });
  }

  render() {
    return (
      <div>
        { this.state.isOpen &&
          <PhotoSwipe
            isOpen={this.state.isOpen}
            items={this.state.items}
            options={this.state.options}
            onClose={this.handleClose}/>
        }
        {this.props.children}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/PhotoSwipeWrapper.js